const state = () => ({
    city_code: '',
    lang: 'ru',
    pizzeria: {
        title: null,
        schedule: {
            start: null,
            finish: null,
        },
        hand_close: {
            comment: null,
            type_id: 0,
            type_title: null,
            type_code: null,
            points: [],
            fully_closed: false,
            state: false
        },
        footer_map: null
    },
    pizzeria_list: [],
    is_pizzeria_closed: false,
    phrases: {},
    banners: [],
    header_menu: [],
    footer_menu: [],
    schedule: [],
    isSizeMd: false,
    openMobileMenu: false,
    openFilter: false,
    waitingOrderTime: 0,
    devMode: false,
    isShowingCabinet: false,
    isSentCheckOrderRequest: false,
    changeLocation: false,
    show_modal_free_delivery_share_condition: false,
    free_delivery_share_condition: null,
    process_discount: false,
    logo: null,
    currentTime: 0,
    session_id: null,
    showIncreaseOrderTimeConformation: false,
    captcha: null,
    showPaidDeliveryConfirmation: false,
    marketplace: {},
    show_mobile_app_banner: false,
    delayThresholdPickup: 0
});

// getters
const getters = {
    getIsDevMode: (state) => {
        return state.devMode;
    },

    getCityCode: (state) => {
        return state.city_code;
    },

    getLang: (state) => {
        return state.lang;
    },

    getPizzeriaInfo: (state) => {
        return state.pizzeria;
    },

    getPhrases: (state) => {
        return state.phrases;
    },

    getHeaderMenu: (state) => {
        return state.header_menu;
    },

    getFooterMenu: (state) => {
        return state.footer_menu;
    },

    getBanners: (state) => {
        return state.banners;
    },

    getIsPizzeriaClosed: (state) => {
        return state.is_pizzeria_closed;
    },

    getChangeLocation: (state) => {
        return state.changeLocation;
    },

    getSchedule: (state) => {
        return state.schedule;
    },

    getIsSizeMd: (state) => {
        return state.isSizeMd;
    },

    isOpenMobileMenu: (state) => {
        return state.openMobileMenu;
    },

    isOpenFilter: (state) => {
        return state.openFilter;
    },

    getWaitingOrderTime(state){
        return state.waitingOrderTime;
    },

    getShowingCabinet: (state) => {
        return state.isShowingCabinet;
    },

    getIsSentCheckOrderRequest: (state) => {
        return state.isSentCheckOrderRequest;
    },

    getPizzeriaList: (state) => {
        return state.pizzeria_list;
    },

    getShowModalFreeDeliveryShareCondition: (state) => {
        return state.show_modal_free_delivery_share_condition;
    },

    getFreeDeliveryShareCondition: (state) => {
        return state.free_delivery_share_condition;
    },

    getProcessDiscount: (state) => {
        return state.process_discount;
    },

    getLogo: (state) => {
        return state.logo;
    },

    currentTime: (state) => {
        return state.currentTime;
    },

    getSessionId: (state) => {
        return state.session_id;
    },

    getShowIncreaseOrderTimeConformation: (state) => {
        return state.showIncreaseOrderTimeConformation;
    },

    getCaptcha: (state) => {
        return state.captcha;
    },

    getShowPaidDeliveryConfirmation: (state) => {
        return state.showPaidDeliveryConfirmation;
    },

    getMarketplace: (state) => {
        return state.marketplace;
    },

    getShowMobileAppBanner: (state) => {
        return state.show_mobile_app_banner;
    },

    getDelayThresholdPickup: (state) => {
        return state.delayThresholdPickup;
    }
}

// actions
const actions = {

    setCityCode({commit}, {code, lang}) {
        commit('setCityCode', {code, lang});
    },

    setInfo({commit}, data) {
        commit('setInfo', data);
    },

    setDeferStartTS({commit}, {deferTS}){
        commit('setDeferStartTS', deferTS);
    }
}

// mutations
const mutations = {
    setCityCode(state, {code, lang}) {
        state.city_code = code;
        state.lang = lang;
    },

    setIsSizeMd(state, isSizeMd) {
        state.isSizeMd = isSizeMd;
    },

    setInfo(state, {pizzeria, phrases, headerMenu, footerMenu, banners, isPizzeriaClosed,
        pizzeria_list, productShares, delayThresholdDelivery, delayThresholdPickup, logo, marketplace}) {
        Object.assign(state.pizzeria, pizzeria);
        state.phrases = phrases;
        state.header_menu = headerMenu;
        state.footer_menu = footerMenu;
        state.banners = banners;
        state.is_pizzeria_closed = isPizzeriaClosed;
        state.pizzeria_list = pizzeria_list;
        state.productShares = productShares;
        state.delayThresholdDelivery = delayThresholdDelivery;
        state.delayThresholdPickup = delayThresholdPickup;
        state.logo = logo;
        state.marketplace = marketplace;
    },

    setTime(state, now){
        Object.assign(state.currentTime, now);
    },

    setPizzeriaHandClose(state, hand_close){
        Object.assign(state.pizzeria.hand_close, hand_close);
    },

    openMobileMenu(state){
        state.openMobileMenu = !state.openMobileMenu;
    },

    setOpenFilter(state){
        state.openFilter = !state.openFilter;
    },

    setDevMode: (state) => {
        state.devMode = true;
    },

    setShowingCabinet: (state) => {
        state.isShowingCabinet = !state.isShowingCabinet;
    },

    setChangeLocation: (state) => {
        state.changeLocation = !state.changeLocation;
    },

    setWaitingOrderTime(state, waitingTime){
        state.waitingOrderTime = waitingTime;
    },

    sentCheckOrderRequest(state, isSent){
        state.isSentCheckOrderRequest = isSent;
    },

    setShowModalFreeDeliveryShareCondition: (state, value) => {
        state.show_modal_free_delivery_share_condition = value;
    },

    setFreeDeliveryShareCondition: (state, value) => {
        state.free_delivery_share_condition = value;
    },

    setProcessDiscount: (state, value) => {
        state.process_discount = value;
    },

    setSessionId: (state, value) => {
        state.session_id = value;
    },

    setShowIncreaseOrderTimeConformation: (state, value) => {
        state.showIncreaseOrderTimeConformation = value;
    },

    setCaptcha: (state, value) => {
        state.captcha = value;
    },

    setShowPaidDeliveryConfirmation: (state, value) => {
        state.showPaidDeliveryConfirmation = value;
    },

    setShowMobileAppBanner: (state, value) => {
        state.show_mobile_app_banner = value;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
